import React from 'react'
import { useNavigate } from 'react-router-dom'
import DeleteIco from '../../../assets/icons/delete.png'
import EditIco from '../../../assets/icons/edit.png'
import CopyIco from '../../../assets/icons/copy.png'
import { auth } from '../../../utitilties/firebase'

const HomeItem = ({ center, clientModal, deleteHandler, modal, onMoveClick, from, therapist }) => {


    const isSuperAdmin = auth?.currentUser?.email == 'admin@orebro.com'

    const navigate = useNavigate()

    const editHandler = (e) => {
        e.stopPropagation()
        navigate('add_physio', { state: { center, edit: true } })
    }

    const copyHandler = (e) => {
        e.stopPropagation()
        const playstoreLink = 'https://play.google.com/store/apps/details?id=com.orebro.app'
       const appStoreLink='https://apps.apple.com/au/app/orebro-10/id6448059973'
        const text = `Welcome to the Orebro 10 application! Download the app here (iOS: , Android:). Sign up on the app with the code ${center.invitationCode} and start completing surveys to track your rehab progress! Play Store: ${playstoreLink}, AppStore: ${appStoreLink}`
        navigator.clipboard.writeText(text)
        alert('Copied')
    }

    return (
        <div
            className='home_item'
            onClick={() => {
                from == 'HOME' && navigate(isSuperAdmin ? '/therapists' : '/clients', { state: { center, therapist: center } });
                from == 'THERAPISTS' && navigate('/clients', { state: { therapist: center } })
                from == 'CLIENTS' && navigate('/surveys', { state: { client: center, therapist } })
            }}

        >
            <p style={{ width: 250, display: 'flex', alignItems: 'center' }} >{center.name} {from == 'CLIENTS' && (center.initialCompleted || center.surveysCompleted) && <div style={{ marginLeft: 5, width: 10, height: 10, borderRadius: 100, backgroundColor: center.surveysCompleted ? 'green' : 'red' }} />} </p>
            <p style={{ width: 250 }} >{center.email}</p>
            {!clientModal && <p style={{ width: 50 }}>{(!modal && isSuperAdmin) ? (center['centerCode'] ? center['centerCode'] + 'XX' : '') : center['invitationCode']}</p>}

            {!modal && !clientModal &&
                <>
                    {isSuperAdmin &&
                        <>

                            <p style={{ width: 150, textAlign: 'center' }} >{center?.therapists?.length}</p>
                            <p style={{ width: 80, textAlign: 'center' }}>{center?.clients}</p>
                        </>}
                        {
                        !isSuperAdmin &&
                        <p style={{ width: 50, textAlign: 'center' }} >{center?.noOfclients}</p>
                    }
                    {
                        !isSuperAdmin &&
                        <img src={CopyIco} style={{ marginLeft: 25 }} className='ico' onClick={(e) => copyHandler(e)} />
                    }
                    
                    <img src={EditIco} style={{ marginLeft: 25 }} className='ico' onClick={editHandler} />
                    <img src={DeleteIco} className='ico' onClick={() => deleteHandler(center.id)} />

                </>}



            {modal && !clientModal && <p style={{ width: 80, textAlign: 'center' }}>{center?.clients?.length}</p>}
            {clientModal &&

                <>
                    <p onClick={onMoveClick} style={{ width: 70, textAlign: 'center', textDecorationLine: 'underline', color: 'blue' }}>move to different therapist</p>
                    <img src={DeleteIco} className='ico' onClick={(e) =>{e.stopPropagation(); deleteHandler(center.id)}} />
                </>
            }
        </div>
    )
}

export default HomeItem